/* SEW Markaz - product recommendations loader

   Dawn ships a <product-recommendations> custom element that fetches the
   Recommendations API and swaps itself out. That element is NOT bundled in
   this theme, which is why "You may also like" rendered an empty section on
   every product page - the markup was there, nothing ever filled it.

   Rather than depend on a file that is missing, this does the same job in
   twenty lines: fetch the section, lift the rendered block out, drop it in.
   Same endpoint, same Shopify-side caching.

   Any element with data-sew-rec and a data-url is handled, so the product page
   and the cart page share one implementation. */

(function () {
  function loadOne(host) {
    if (host.dataset.sewLoaded === 'true') return;
    var url = host.getAttribute('data-url');
    if (!url) return;
    host.dataset.sewLoaded = 'true';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sew-rec]');
        if (!fresh || !fresh.innerHTML.trim()) return;
        host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        /* An empty recommendations block is a quiet failure, not a broken page. */
      });
  }

  function loadAll() {
    document.querySelectorAll('[data-sew-rec]').forEach(loadOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAll);
  } else {
    loadAll();
  }
  document.addEventListener('shopify:section:load', loadAll);
})();
